import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateVenueContact($companyId: ID!, $attributes: VenueContactAttributes!) {
    createVenueContact(companyId: $companyId, attributes: $attributes) {
      venueContact {
        id
        ...CreatedVenueContact
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedVenueContact on VenueContact {
    id
    name
    email
    phone
    color
    contactType
    user { id displayName email }
  }
`
